.modalAlert {
    align-items: center;
    margin-bottom: 10px;
}

.inviteRecipientList {
    margin: 4px 0 0;
    padding-left: 20px;
    word-break: break-all;
}
